import { UploadFileResponse } from 'basics/graphql/mutations/uploadFiles';
import { convertFileSizeToKb } from 'basics/utils/files/files.utils';

type TransformMediaToCard = (item: UploadFileResponse) => Omit<UploadFileResponse, 'size'> & { size: string };

export const transformMediaToCard: TransformMediaToCard = (item) => ({
  ...item,
  size: convertFileSizeToKb(item.size),
});
